import { render, staticRenderFns } from "./SiteWideBanner.vue?vue&type=template&id=db14a3a6&scoped=true"
import script from "./SiteWideBanner.vue?vue&type=script&lang=js"
export * from "./SiteWideBanner.vue?vue&type=script&lang=js"
import style0 from "./SiteWideBanner.vue?vue&type=style&index=0&id=db14a3a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db14a3a6",
  null
  
)

export default component.exports